import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-120" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-121" data-mp="1r9uia68x2wfa">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-122" data-mp="1rb5n89e3ma7z">
          <span aria-hidden="true" data-id="element-123" data-mp="1hj9oqx83oi38">📲 </span>What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-124" data-mp="1hhgez926xhr0">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm font-medium text-stone-800" data-id="element-125" data-mp="1mbawq6y8jmng">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-126" data-mp="1cl82k3fdo2nj" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-bold italic text-red-500 sm:text-xl" data-id="element-127" data-mp="13i6zkblt6ro3">
          You cover the entire guest journey — from booking to farewell — in
          one click.
        </p>
      </div>
    </section>;
}